import FetchToBlob from "./FetchToBlob";
import BlobToBase64 from "./BlobToBase64";

export default async (url, saveMetaData = false) => {
    return new Promise(async (res) => {
        const blobPromise = await FetchToBlob(url);
        if (!blobPromise) {
            res(false);
        }
        const result = await BlobToBase64(blobPromise, saveMetaData);
        if (!result) {
            res(false)
        }
        res(result);
    })
}